module.exports = __webpack_public_path__ + "static/img/tip2.04a4a2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/tip2.png
// module id = 0yTk
// module chunks = 1